import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useForm } from '../hooks';

import { Grid, Typography } from '@mui/material';

import { Button, TextField } from '../components/common';
import colors from '../assets/colors';
import { password } from '../utils/api';

export default function SetPassword(props) {
  const history = useHistory();
  const [isPasswordSet, setIsPasswordSet] = useState(false);
  const [notMatching, setNotMatching] = useState(false);
  const { handleChange, values } = useForm({
    password: '',
    repeatPassword: '',
  });

  const setPassword = () => {
    password
      .setPassword({ password: values.password })
      .then((res) => {
        setIsPasswordSet(true);
      })
      .catch((err) => {});
  };

  useEffect(() => {
    if (values.password !== values.repeatPassword) setNotMatching(true);
    else setNotMatching(false);
  }, [values]);

  return (
    <>
      <Grid
        container
        spacing={4}
        direction="column"
        justifyContent="center"
        alignItems="center"
      >
        {!isPasswordSet ? (
          <>
            <Grid item xs={12}>
              <Typography
                sx={{
                  color: colors.agroweGreen,
                  fontSize: 28,
                  fontWeight: 500,
                }}
              >
                Podaj hasło do swojego konta
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <TextField
                modalRight
                type="password"
                label="Hasło"
                sx={{ my: 0 }}
                error={notMatching}
                onChange={handleChange('password')}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                modalRight
                type="password"
                label="Powtórz hasło"
                sx={{ my: 0 }}
                error={notMatching}
                onChange={handleChange('repeatPassword')}
              />
            </Grid>
            {notMatching && (
              <Grid item xs={12}>
                <Typography sx={{ color: colors.redError }}>
                  Podane hasła różnią się od siebie!
                </Typography>
              </Grid>
            )}
            <Grid item xs={12}>
              <Button
                agroweGreen
                variant="outlined"
                onClick={setPassword}
                disabled={notMatching || values.password === ''}
              >
                USTAW HASŁO
              </Button>
            </Grid>
          </>
        ) : (
          <>
            <Grid item xs={12} sx={{ textAlign: 'center' }}>
              <Typography
                sx={{
                  color: colors.agroweGreen,
                  fontSize: 40,
                  fontWeight: 500,
                }}
              >
                Twoje hasło zostało ustawione!
              </Typography>
              <Typography
                sx={{
                  color: colors.agroweGreen,
                  fontSize: 40,
                  fontWeight: 500,
                }}
              >
                Możesz swobodnie korzystać ze swojego konta.
              </Typography>
              <Button
                agroweGreen
                variant="outlined"
                sx={{ mt: 3, fontSize: 20 }}
                onClick={() => history.push('/login')}
              >
                PRZEJDŹ NA STRONĘ LOGOWANIA
              </Button>
            </Grid>
          </>
        )}
      </Grid>
    </>
  );
}
